'use strict'

import React from 'react'
import $     from 'jquery'

export default class YourDetails extends React.Component {
  updateLocation (e) {
    let invalid = !/\d{4}/.test(e.target.value)

    e.target.style.borderColor = invalid ? '#EF5350' : '#26A69A'

    this.props.onChange('location', {
      displayName: 'Location',
      value: e.target.value,
      pageRef: 'book-your-appointment',
      order: 14,
      displayInSummary: true,
      invalid: invalid
    })

    $(e.target).toggleClass('required', invalid)

    // this.focus.bind(this)
  }

  updateFirst (e) {
    const fname = document.getElementById('first-name').value
    const lname = document.getElementById('last-name').value

    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Details - Interaction'
    })

    let invalid = !/\S+/.test(e.target.value)

    e.target.style.borderColor = invalid ? '#EF5350' : '#26A69A'

    this.props.onChange('full-name', {
      displayName: 'Name',
      value: fname + ' ' + lname,
      pageRef: 'your-details',
      order: 3,
      displayInSummary: true
    })

    this.props.onChange('first-name', {
      displayName: 'First Name',
      value: fname,
      pageRef: 'your-details',
      order: 3,
      displayInSummary: false,
      invalid: invalid
    })

    $(e.target).toggleClass('required', invalid)
  }

  updateLast (e) {
    const fname = document.getElementById('first-name').value
    const lname = document.getElementById('last-name').value

    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Details - Interaction'
    })

    let invalid = !/\S+/.test(e.target.value)

    e.target.style.borderColor = invalid ? '#EF5350' : '#26A69A'

    this.props.onChange('full-name', {
      displayName: 'Name',
      value: fname + ' ' + lname,
      pageRef: 'your-details',
      order: 3,
      displayInSummary: false
    })

    this.props.onChange('last-name', {
      displayName: 'Last Name',
      value: lname,
      pageRef: 'your-details',
      order: 3,
      displayInSummary: false,
      invalid: invalid
    })

    $(e.target).toggleClass('required', invalid)
  }

  updateContactNumber (e) {
    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Details - Interaction'
    })

    let invalid = !/\d+/.test(e.target.value)

    e.target.style.borderColor = invalid ? '#EF5350' : '#26A69A'

    this.props.onChange('contact-number', {
      displayName: 'Contact Number',
      value: e.target.value,
      pageRef: 'your-details',
      order: 3,
      displayInSummary: true,
      invalid: invalid
    })

    $(e.target).toggleClass('required', invalid)
  }

  updateEmailAddress (e) {
    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Details - Interaction'
    })

    let invalid = !/.+@.+\..+/.test(e.target.value)

    e.target.style.borderColor = invalid ? '#EF5350' : '#26A69A'

    this.props.onChange('contact-email', {
      displayName: 'Contact Email',
      value: e.target.value,
      pageRef: 'your-details',
      order: 3,
      displayInSummary: true,
      invalid: invalid
    })

    $(e.target).toggleClass('required', invalid)
  }

  focus () {
    if (!this.focused) {
      this.focused = true

      window.ga('send', 'event', {
        eventCategory: 'Detailed Form',
        eventAction: 'Click',
        eventLabel: 'Details - Interaction'
      })
    }
  }

  render () {
    const summary = this.props.summary || {}

    return (
      <section className='your-details'>
        <h2 className='header'>Your Details</h2>
        <div>
          <div className='input-row name-input'>
            <input
              id='first-name'
              type='text'
              placeholder='First Name'
              className='half-width required'
              onFocus={this.focus.bind(this)}
              defaultValue={summary['full-name'] ? summary['full-name'].value.split(' ')[0] : ''}
              onChange={this.updateFirst.bind(this)} />
            <br />
            <input
              id='last-name'
              type='text'
              placeholder='Family Name'
              className='half-width last-name required'
              onFocus={this.focus.bind(this)}
              defaultValue={summary['full-name'] ? summary['full-name'].value.split(' ')[1] : ''}
              onChange={this.updateLast.bind(this)} />
            <br />
            <input
              type='text'
              placeholder='Phone Number'
              onChange={this.updateContactNumber.bind(this)}
              onFocus={this.focus.bind(this)}
              defaultValue={summary['contact-number'] ? summary['contact-number'].value : ''}
              className='half-width required' />
            <br />
            <input
              type='email'
              placeholder='Email'
              onChange={this.updateEmailAddress.bind(this)}
              onFocus={this.focus.bind(this)}
              defaultValue={summary['contact-email'] ? summary['contact-email'].value : ''}
              className='half-width required' />
            <br />
            <input
              type='text'
              placeholder='Postcode'
              onChange={this.updateLocation.bind(this)}
              onFocus={this.focus.bind(this)}
              defaultValue={summary['location'] ? summary['location'].value : ''}
              className='half-width required' />
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/your-details.js